import { useMutation } from '@tanstack/react-query'
import FileIcon from 'assets/icons/FileIcon'
import useDialog from 'hooks/Shared/useDialog'
import { uploadZipFileService } from 'services/Invoices/invoices.services'

interface IUploadZipCFDIsParams {
  file: File
  workspaceId: number
}

const useUploadZipCFDIs = (handleClose: () => void) => {

  const dialog = useDialog()

  const mutation = useMutation<void, Error, IUploadZipCFDIsParams>(
    async ({ file, workspaceId }) =>
      await uploadZipFileService({
        file: file,
        workspaceId: workspaceId,
      }),
    {
      onSuccess: () => {
        dialog.info({
          title: 'Estamos procesando tus CFDIs',
          subtitle: 'Esto puede tomar algún tiempo.',
          message: `Cuando tu archivo haya terminado de procesarse, recibirás un correo electrónico con los detalles de la carga.`,
          onClose: dialog.close,
          icon: FileIcon,
        })
      },
      onError: (_, { file: { name }}) => {
        dialog.danger({
          className: 'invoices-upload-dialog',
          title: 'Tu carga no ha sido procesada',
          message: `No fue posible cargar los CFDIs del archivo que seleccionaste:`,
          modalContent: (
            <div className="invoices-manual-xml-upload-content">
              <div className="invoices-manual-xml-upload-content-list">
                <span>{name}</span>
              </div>
            </div>
          ),
          onClose: dialog.close
        })
      },
      onSettled: () => {
        handleClose()
      },
    }
  )
  return mutation
}

export default useUploadZipCFDIs
